import { fireEwToast, type EwToastType } from "./ewToast";

/** `heading` overrides the title row; when omitted, the variant name is shown (e.g. "Success"). */
export function showToast(
  type: EwToastType,
  message: string | JSX.Element,
  heading?: string
): void {
  fireEwToast(type, message, heading);
}
